import React from "react";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Gallery from "@/components/sections/Gallery";
import Reviews from "@/components/sections/Reviews";
import Contact from "@/components/sections/Contact";
import Payments from "@/components/sections/Payments";

export default function HomePage({ t, lang }) {
  return (
    <>
      <Hero t={t} />
      <About t={t} />
      <Services t={t} />
      <Gallery t={t} />
      <Reviews t={t} />
      <Contact t={t} lang={lang} />
      <Payments t={t} />
    </>
  );
}
